// verifica que el momento A sea previo al momento B
export const EsPrevio = (tiempoA, minutosA, tiempoB, minutosB) => {
  return tiempoA < tiempoB || (tiempoA === tiempoB && minutosA < minutosB);
};

// verifica que el momento A sea posterior al momento B
export const EsPosterior = (tiempoA, minutosA, tiempoB, minutosB) => {
  return tiempoA > tiempoB || (tiempoA === tiempoB && minutosA > minutosB);
};
